const validateObject = object => {
  if (typeof object !== 'object') {
    throw TypeError(`Invalid type: ${typeof object}, expecting object`);
  }
};

export const getObjectFromLocalStorage = key => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    // Handle corrupted localStorage data or JSON parse errors
    return null;
  }
};

export const updateObjectInLocalStorage = (key, object) => {
  try {
    validateObject(object);
    const item = localStorage.getItem(key);
    const parsedItem = item ? JSON.parse(item) : {};
    localStorage.setItem(
      key,
      JSON.stringify({
        ...parsedItem,
        ...object,
      })
    );
  } catch (error) {
    // Handle corrupted localStorage data, JSON parse errors, or quota exceeded
    // Try to set the object directly as a fallback
    try {
      localStorage.setItem(key, JSON.stringify(object));
    } catch (fallbackError) {
      // Fallback failed, silently ignore
    }
  }
};

export const setObjectInLocalStorage = (key, object) => {
  try {
    localStorage.setItem(key, JSON.stringify(object));
  } catch (error) {
    // Handle localStorage quota exceeded or other storage errors
  }
};

export const clearObjectInLocalStorage = key => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    // Handle localStorage access errors
  }
};
